// extracted by mini-css-extract-plugin
export default {"container":"style_container__TyADA","header":"style_header__4NZF5","content":"style_content__eOSZ7","desc":"style_desc__ewmbg","contact":"style_contact__1ZVeG"};